import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["CustomSelector"], {
    "z-index": 100000000000,
    state: $props.stateError ? 'error' : 'default',
    supportingText: $props.stateError ?? undefined,
    ref: "stateSelector",
    "empty-message": "Estado",
    ",": "",
    initialSelection: $setup.initialSelection ?? undefined,
    options: Object.keys($setup.StatesEnum).map((key) => ({
      title: key.replaceAll('_', ' '),
      })),
    onChange: _cache[0] || (_cache[0] = (_, index) => {
        $setup.state = index !== null ? $setup.StatesEnum[Object.keys($setup.StatesEnum)[index]] : null;
        _ctx.$emit('change',  $setup.state)
      })
  }, null, 8 /* PROPS */, ["state", "supportingText", "initialSelection", "options"]))
}